import React from "react";
import { Colors } from "../../Constants/colors";

interface Props {
  img: string;
  badgeValue: any;
  imageStyle?: object;
  wrapperStyle?: object;
  onClick?: () => unknown;
}

export const IconWithBadge = ({
  img,
  badgeValue,
  imageStyle = {},
  wrapperStyle = {},
  onClick,
}: Props) => {
  return (
    <>
      <div
        style={{
          position: "relative",
          cursor: "pointer",
          ...wrapperStyle,
        }}
        onClick={onClick}
      >
        {!!badgeValue ? (
          <span
            style={{
              position: "absolute",
              top: "-5px",
              right: "-5px",
              backgroundColor: Colors.Tomato,
              color: "white",
              width: "15px",
              height: "15px",
              borderRadius: "50%",
              padding: "1px 1px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "8px",
              fontWeight: 800,
            }}
          >
            {badgeValue}
          </span>
        ) : (
          <div />
        )}

        <img
          src={img}
          alt="iconWithBadge"
          style={{
            width: "22px",
            height: "22px",
            ...imageStyle,
          }}
        />
      </div>
    </>
  );
};
